/**
 * Formats a SQLite datetime string for display in the browser's timezone.
 *
 * SQLite's datetime('now') returns UTC timestamps in the format "YYYY-MM-DD HH:MM:SS"
 * without a timezone indicator. JavaScript's new Date() interprets strings without
 * a timezone suffix as local time, which causes incorrect display. This function
 * appends 'Z' (UTC) when needed so the browser correctly converts to local time.
 */
export function formatTimestamp(timestamp: string): string {
  return new Date(ensureUtc(timestamp)).toLocaleString();
}

export function formatDate(timestamp: string): string {
  return new Date(ensureUtc(timestamp)).toLocaleDateString();
}

function ensureUtc(timestamp: string): string {
  // Already has timezone info (ISO 8601 with T and Z, or offset like +00:00)
  if (timestamp.includes('T') || timestamp.includes('Z') || /[+-]\d{2}:\d{2}$/.test(timestamp)) {
    return timestamp;
  }
  // SQLite format "YYYY-MM-DD HH:MM:SS" -- replace space with T and append Z
  return timestamp.replace(' ', 'T') + 'Z';
}
